<template>
  <v-main>
    <PageWrapper class="pa-0">
      <PageContent>
        <v-row no-gutters align="center" justify="start" class="pa-4">
          <v-col cols="12" class="mt-4">
            <v-expansion-panels
              v-model="panel">
              <v-expansion-panel value="0">
                <v-expansion-panel-header>
                  Filtros
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col
                      class="d-flex justify-center align-center"
                      cols="3"
                    >
                      <v-select
                        v-model="filter.idPessoa"
                        :items="getPessoas"
                        :item-text="'nome'"
                        :item-value="'id'"
                        outlined
                        label="Pessoas"
                      ></v-select>
                    </v-col>
                    <v-col
                        class="d-flex justify-center align-center"
                        cols="3"
                      >
                        <v-select
                          v-model="filter.idObra"
                          :items="getAllObrasCustom"
                          :item-text="'nome'"
                          :disabled="disabledObra"
                          :item-value="'id'"
                          outlined
                          label="Unidades"
                        ></v-select>
                      </v-col>
                      <v-col
                        class="d-flex"
                        cols="3"
                      >
                        <v-select
                        :items="periodos"
                        item-text="descricao"
                        item-value="id"
                        outlined
                        v-model="periodoSelecionado"
                        ></v-select>
                      </v-col>
                      <v-col
                        class="d-flex"
                        cols="3"
                      >
                      </v-col>
                      <v-col
                        class="d-flex"
                        cols="3"
                      >
                      <v-text-field
                        v-model="data_inicio"
                        v-mask="'##/##/####'"
                        required
                        label="De"
                        outlined
                      ></v-text-field>
                      </v-col>
                      <v-col
                        class="d-flex"
                        cols="3"
                      >
                        <v-text-field
                          v-model="data_fim"
                          v-mask="'##/##/####'"
                          required
                          label="Até"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col
                        class="d-flex"
                        cols="3"
                      >
                      </v-col>
                      <v-col cols="3" class="d-flex justify-center align-center pb-8">
                        <v-btn
                          color="#27997c"
                          dark
                          class="mb-2"
                          @click="searchByFilter"
                        >
                        <v-icon>mdi-magnify</v-icon>
                          Pesquisar
                        </v-btn>
                      </v-col>
                  </v-row>

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <div class="mb-2 btn-new">
          <v-btn
            color="#27997c"
            dark
            class="mb-2"
            @click="openDialog = !openDialog"
            v-on="on"
          >
          <v-icon>mdi-plus</v-icon>
            Adicionar Novo
          </v-btn>
        </div>
        <v-data-table
        :headers="headers"
        :items="getListCustom"
        :loading="loading"
        :search="search"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar
              flat
            >
              <v-toolbar-title>Listagem de Entradas</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                dense
                outlined
                label="Buscar"
                append-icon="mdi-magnify"
              ></v-text-field>

            </v-toolbar>
          </template>
          <template v-slot:item.valor="{ item }">
            {{ item.valor | localCurrency }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              color="warning"
              small
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              color="red"
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <span>Sem dados disponíveis</span>
        </template>
        </v-data-table>
        <AddModalVue :openDialog="openDialog" @closeModal="closeModal" @searchByFilter="searchByFilter"/>
        <EditModal :objValue="objEdit" :dialogEdit="dialogEdit" @closeEditItem="closeEditItem" @searchByFilter="searchByFilter" />
        <DeleteModal :dialogDelete="dialogDelete" :objValue="objEdit" @deleteItemConfirm="deleteItemConfirm" @closeDeleteItem="closeDeleteItem" @searchByFilter="searchByFilter"/>
      </PageContent>
    </PageWrapper>
  </v-main>
</template>

<script>
import PageWrapper from '@/components/template/PageWrapper.vue';
import PageContent from '@/components/template/PageContent.vue';
import { mapGetters, mapActions } from 'vuex';
import AddModalVue from './AddModal.vue'
import EditModal from './EditModal.vue'
import DeleteModal from './DeleteModal.vue'
import date from '../../../../utils/date'
import user from '@/utils/user.json';
  export default {
    components:{
    PageWrapper,
    PageContent,
    AddModalVue,
    EditModal,
    DeleteModal
  },
    data: () => ({
      search:'',
      filter: {
        idPessoa: null,
        idEmpresa: null,
        user,
        idObra: null,
      },
      disabledObra: false,
      periodoSelecionado: null,
      periodos:[
      {
        descricao: "Todos os dias",
        id: null
      },
      {
        descricao: "ultimos 7 dias",
        id: 7
      },
      {
        descricao: "ultimos 15 dias",
        id: 15
      },
      {
        descricao: "ultimos 30 dias",
        id: 30
      }],
      openDialog: false,
      dialogEdit:false,
      dialogDelete: false,
      data_inicio: '',
      data_fim: '',
      loading:false,
      objEdit:{},
      headers: [
        { text: 'Empresa', value: 'empresa.nome',  sortable: false,  align: 'center',  },
        { text: 'Descrição Manual', value: 'descricao',  sortable: false,  align: 'start', },
        { text: 'Parcelamento', value: 'parcela',  sortable: false,  align: 'start', },
        { text: 'Obra', value: 'obra.nome',  sortable: false,  align: 'center',  },
        { text: 'NFE', value: 'nfe',  sortable: false,  align: 'center',  },
        { text: 'Data de vencimento', value: 'data_vencimento',  sortable: false,  align: 'start', },
        { text: 'Valor', value: 'valor',  sortable: false,  align: 'start', },
        { text: 'Ações', value: 'actions', sortable: false, align: 'start',  },
      ],
      entradas: [],
      editedIndex: -1,
    }),
    computed: {
      ...mapGetters('entrada',['getList']),
      ...mapGetters('pessoa', {getPessoas:'getList'}),
      ...mapGetters('obra', {getObras:'getList'}),
      getAllObrasCustom(){
        const email = localStorage.getItem("email_logged");
        const userLogged = user.find((item)=> item.email == email);
        if(userLogged.obras && this.filter){
          this.disabledObra = true;
          this.filter.idObra = userLogged.obras[0];
          return this.getObras.filter((item)=>{
            const obrasPermitidas = userLogged.obras;
            return obrasPermitidas.find((itemId)=> item.id === itemId)
          });
        }

        return this.getObras;
      },
      getListCustom(){
        
        const list = Object.assign([], this.getList.map((item )=>{
          return {
            ...item,
            dataEntradaObj: this.transformDateFormat(item.data_entrada)
          }
        }));
        const listOrdered = list.sort(function(a,b){
          return b.dataEntradaObj - a.dataEntradaObj;
        });
        if( listOrdered && listOrdered.length > 0)
          listOrdered.push({
              pessoa:{
                nome: ''
              },
              obra:{
                nome: '- '
              },
              data: 'Total',
              valor: this.getList.map(item => Number(item.valor) ).reduce((acumulado, valorAtual) => acumulado + valorAtual),
              actions: ''
          })
        else
          return []

        return listOrdered
      },
    },
    async created () {
       // await this.getAllEntradas ()
       await this.searchByFilter()
       await this.getAllPessoas()
    },
    methods: {
      ...mapActions('entrada', ['getAllEntradas','getEntradasByFilter']),
      ...mapActions('pessoa', ['getAllPessoas']),
      initialize () {
        this.entradas = ['']
      },
      transformDateFormat(dateString) {
        var dateParts = dateString.split("/");
        return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      },
      addLeadingZero(number) {
        return number < 10 ? '0' + number : number;
      },
      calcularPeriodo(dias) {
        // Get today's date
        let today = new Date();
        let listIntervalos = [];

        // Loop to get the last 7 dates
        for (let i = 0; i < dias; i++) {
          // Use getTime() to get the timestamp, subtract i days, and create a new Date object
          let currentDate = new Date(today.getTime() - i * 24 * 60 * 60 * 1000);

          // Get day, month, and year
          let day = this.addLeadingZero(currentDate.getDate());
          let month = this.addLeadingZero(currentDate.getMonth() + 1); // Months are zero-based
          let year = currentDate.getFullYear();

          // Display the date in dd/mm/yyyy format
          listIntervalos.push((day + '/' + month + '/' + year));
        }
        return listIntervalos;   
      },
      formatDate(inputDate) {
          // Split the input date string by "/"
          let parts = inputDate.split("/");
          
          // Rearrange the parts to the format "yyyy-mm-dd"
          let formattedDate = parts[2] + '-' + parts[1] + '-' + parts[0];
          
          return formattedDate;
      },
      async searchByFilter() {
        if(this.data_inicio && this.data_fim){
          this.filter.periodos = date.getDates(this.formatDate(this.data_inicio), this.formatDate(this.data_fim)).map((itemDate)=> date.formatDateToDDMMYYYY(itemDate));
          this.filter.periodos.shift();
          if(this.filter.periodos.length > 30){
            alert('Periodo superior a 31 dias. favor usar um periodo mais curto');
            return 
          }
        }else{
          if(this.periodoSelecionado){
            this.filter.periodos = this.calcularPeriodo(this.periodoSelecionado)
          }else{
            this.filter.periodos = []
          }
        }
        console.log(this.filter.periodos);
        await this.getEntradasByFilter(this.filter)
      },
      deleteItem (item) {
        this.objEdit = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.getList.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      editItem (item) {
          this.objEdit = Object.assign({}, item)
          this.dialogEdit = true
      },
      closeDeleteItem () {
        this.dialogDelete = false;
      },
      closeEditItem () {
         this.dialogEdit = false;
      },
      closeModal () {
        this.openDialog = false;
      },
      close () {
        this.dialog = true
      }
    }
  }
</script>

<style >

.menu {
  width: 80%;
  padding-top: 70px;
  position: absolute;
}
.btn-new{
  margin-right: 24px;
  padding-top: 10px;
  justify-content: flex-end;
  display: flex;
}
.title-card{
  background: #272727;
  color: white;
  padding: 20px !important;
}
.v-card__text {
  padding-top: 20px !important;
}
</style>
